const initialState = { userAgent: '' };

const common = (state = initialState, action) => {
    switch (action.type) {
        default:
            return state;
    }
};

export default common;